require('./bootstrap');
require('jquery-validation');

$(document).on('click', '#pagination a', function(event) {
    event.preventDefault();

    let url = $(this).attr('href');
    window.history.pushState({}, null, url);
    
    $.ajax({
        type: 'POST',
        url: url,
        success:function(data) {
            $('#list-ajax').html(data);
            $('html, body').animate({
                scrollTop: $("#list-ajax").parent().offset().top
            }, 1000);
        }
    });
    return false;
})

window.setShareLinks = function () {
    var pageUrl = encodeURIComponent(document.URL);
    var title = encodeURIComponent(document.title);

    $(".icon-social.icon-fb.share").on("click", function() {
        url = "https://www.facebook.com/sharer.php?u=" + pageUrl;
        socialWindow(url);
    });

    $(".icon-social.icon-tw.share").on("click", function() {
        url = "https://twitter.com/intent/tweet?url=" + pageUrl + "&text=" + title;
        socialWindow(url);
    });

    $(".icon-social.icon-wa.share").on("click", function() {
        url = "https://api.whatsapp.com/send?text=" + title + ' ' + pageUrl;
        socialWindow(url, '_blank');
    });
}

window.socialWindow = function (url, target = null) {
    var left = (screen.width - 570) / 2;
    var top = (screen.height - 570) / 2;
    var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
    if(target) {
        window.open(url, target);
    }

    window.open(url, "NewWindow", params);
}

